import { Attr, BelongsTo, Model } from "spraypaint";

import type { Chart } from "shared/modules/Charts/types/chartTypes";
import { ApplicationRecord } from "shared/services/spraypaint";

import type InsightsReport from "./InsightsReport";

@Model()
class InsightsReportChart extends ApplicationRecord {
  static jsonapiType = "insights_report_charts";

  @Attr() annotatable: boolean;

  @Attr() chart: Chart;

  @Attr() group: string;

  @BelongsTo() insightsReport: InsightsReport;

  @Attr() insightsReportId: number;

  @Attr() position: number;
}

export default InsightsReportChart;
